import SelectRange from "./selectRange/SelectRange";
import Generating from "./generating/Generating";
import GenerationResult from "./generateResult/GenerationResult";
import { GenerationProvider } from "./providers/GenerationProvider";
import useGeneration from "./hooks/useGeneration";

const GenerationPage = () => {
  const { step } = useGeneration();

  if (step === "generating") {
    return <Generating />;
  }

  if (step === "result") {
    return <GenerationResult />;
  }

  return <SelectRange />;
};

const GenerationPageWithProvider = () => {
  return (
    <GenerationProvider>
      <GenerationPage />
    </GenerationProvider>
  );
};

export default GenerationPageWithProvider;
